import { FC } from 'react';

const Events: FC = () => {
  return (
    <div>
      <h1>Hello, this is the Events page</h1>
    </div>
  );
};

export default Events;
